module.exports = require("@nguniversal/module-map-ngfactory-loader");